module.exports = __webpack_public_path__ + "static/img/患者管理@2x1.9f4e9076.png";